module.exports = __webpack_public_path__ + "img/img-4.b4b6f3b0.jpg";